export default __webpack_public_path__ + "static/media/footer_linkedin.14e45ace.svg";